import "core-js/modules/es.number.constructor";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-chart-gauge",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  watch: {
    'option.attribute': {
      handler: function handler(newObj) {
        this.loadChart(newObj);
      },
      deep: true //深度监听

    },
    width: function width() {
      this.chart.resize();
    },
    height: function height() {
      this.chart.resize();
    }
  },
  data: function data() {
    return {
      uuid: '',
      chartOption: {},
      chart: null,
      cptData: {}
    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
  },
  mounted: function mounted() {
    this.chart = this.$echarts.init(document.getElementById(this.uuid), 'dark');
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "ChartGauge").then(function (res) {
        _this.cptData = res;

        _this.loadChart(_this.option.attribute);
      });
    },
    loadChart: function loadChart(attribute) {
      var that = this;
      that.chartOption = {
        backgroundColor: '',
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [{
          name: 'Pressure',
          type: 'gauge',
          startAngle: attribute.startAngle,
          endAngle: attribute.endAngle,
          radius: '100%',
          min: attribute.min,
          max: attribute.max,
          axisLabel: {
            distance: attribute.labelDistance,
            color: '#999',
            fontSize: attribute.labelSize
          },
          axisTick: {
            show: true,
            length: attribute.tickLength,
            distance: attribute.lineDistance
          },
          splitLine: {
            distance: attribute.lineDistance,
            length: attribute.tickLength * 1.5,
            lineStyle: {
              width: 2,
              color: '#999'
            }
          },
          axisLine: {
            lineStyle: {
              width: attribute.lineWidth,
              color: [[0.3, attribute.color1], [0.7, attribute.color2], [1, attribute.color3]]
            }
          },
          progress: {
            show: true,
            width: attribute.lineWidth
          },
          pointer: {
            length: attribute.pointerLength + '%',
            width: attribute.pointerWidth
          },
          itemStyle: {
            color: attribute.itemColor
          },
          title: {
            show: true,
            fontSize: attribute.titleSize,
            color: attribute.titleColor
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}',
            color: attribute.detailColor,
            fontSize: attribute.detailSize
          },
          data: [{
            value: that.cptData.value,
            name: attribute.title
          }]
        }]
      };
      that.chart.setOption(that.chartOption);
    }
  }
};